"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _setCookie = _interopRequireDefault(require("./setCookie"));
var jwtUtils = require('./jwtUtils');
var clearCredentials = require('./clearCredentials');
var SIGN_IN_MODES = require('./constants');
var SIX_MONTHS_IN_MILLISECONDS = 6 * 30 * 24 * 60 * 60 * 1000;
var setCredentials = {
  setSignInMode: function setSignInMode(mode) {
    return (0, _setCookie["default"])('signInMode', mode, new Date().getTime() + SIX_MONTHS_IN_MILLISECONDS);
  },
  cognito: function cognito(idToken) {
    if (!idToken) return;
    clearCredentials.microsoft();
    clearCredentials.google();
    var tokenExpiry = jwtUtils.getTokenExpiryTimeAsGMTString(idToken);
    (0, _setCookie["default"])('cognitoIdToken', idToken, tokenExpiry);
    setCredentials.setSignInMode(SIGN_IN_MODES.cognito);
  },
  microsoft: function microsoft(credentials) {
    if (!credentials || !credentials.id_token || !credentials.expiry_date || !credentials.refresh_token) return;
    (0, _setCookie["default"])('microsoftIdToken', credentials.id_token, credentials.expiry_date + SIX_MONTHS_IN_MILLISECONDS);
    (0, _setCookie["default"])('microsoftRefreshToken', credentials.refresh_token, credentials.expiry_date + SIX_MONTHS_IN_MILLISECONDS);
    setCredentials.setSignInMode(SIGN_IN_MODES.microsoft);
  },
  google: function google(credentials) {
    if (!credentials || !credentials.id_token || !credentials.expiry_date || !credentials.refresh_token) return;
    clearCredentials.cognito();
    clearCredentials.microsoft();
    (0, _setCookie["default"])('googleIdToken', credentials.id_token, credentials.expiry_date + SIX_MONTHS_IN_MILLISECONDS);
    (0, _setCookie["default"])('googleRefreshToken', credentials.refresh_token, credentials.expiry_date + SIX_MONTHS_IN_MILLISECONDS);
    setCredentials.setSignInMode(SIGN_IN_MODES.google);
  }
};
module.exports = setCredentials;